import {useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import {OperationStateType, OperationStateTypesEnum, SignInEnum} from 'presentation/constants';
import {APIError} from 'data/errors';
import {makeSignUpUpdate} from 'main/factories/usecases';
import {IFormData} from '../first-access/components/FirstAccessForm/schema';

export function useFirstAccess() {
	const [requestState, setRequestState] = useState<OperationStateType | null>(null);
	const [alertModalState, setAlertModalState] = useState(false);
	const navigate = useNavigate();
	const {state} = useLocation();

	const showAPIError = requestState === OperationStateTypesEnum.ERROR;
	const showConfirmationModal = requestState === OperationStateTypesEnum.DONE;

	const handleSubmitRequest = async ({password, cellphone, email, repeatPassword}: IFormData) => {
		try {
			if (state.cdAcesso && state.login_token) {
				setRequestState(OperationStateTypesEnum.PENDING);
				await makeSignUpUpdate().signUpUpdate({
					contraSenha: repeatPassword,
					novaSenha: password,
					cdAcesso: state.cdAcesso,
					celular: cellphone,
					email,
					login_token: state.login_token,
				});
				setRequestState(OperationStateTypesEnum.DONE);
				setAlertModalState(true);
			} else {
				navigate(SignInEnum.SIGN_IN, {state: {goToSignInState: true}});
			}
		} catch (error) {
			if (error instanceof APIError) {
				setRequestState(OperationStateTypesEnum.ERROR);
				setAlertModalState(true);
			}
		}
	};

	return {
		handleSubmitRequest,
		showAPIError,
		showConfirmationModal,
		setAlertModalState,
		alertModalState,
	};
}
